import validateEmail from '../../../helpers/validateEmail';

export const phoneValidator = (_rule, value, callback) => {
  const regEx = /^\+\d{11}$/;

  if (value && !regEx.test(value)) {
    callback('Проверьте правильность номера. Пример: +79876543210');
  } else {
    callback();
  }
};

export const emailValidator = (_rule, value, callback) => {
  if (value && !validateEmail(value)) {
    callback('Укажите действительную почту');
  } else {
    callback();
  }
};

export const numFieldValidator = (_rule, value, callback) => {
  const regEx = /^\d+$/;
  if (value && !regEx.test(value)) {
    callback('Номер паспорта должен содержать только цифры');
  } else {
    callback();
  }
};
